import {
    BasicInfoBeneficiary,
    SupplierEquipmentForm,
} from './components';

export const stepsEquipmentSupplier = [
  {
    name: 'SUPPLIEREQUIPMENTFORM',
    label: 'Εξοπλισμός',
    Component: SupplierEquipmentForm,
    id: 0,
  },
];